import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const PlaceholderCard = ({ title, message }) => (
  <Card>
    <CardContent sx={{ py: 1.25, px: 1.5, '&:last-child': { pb: 1.25 } }}>
      <Typography variant="subtitle1" sx={{ mb: 0.5, fontWeight: 700 }}>{title}</Typography>
      <Typography variant="body2" sx={{ opacity: 0.8 }}>
        {message}
      </Typography>
    </CardContent>
  </Card>
);

export default PlaceholderCard;
